import axios from 'axios';

export default {
  fetchVIN(context, license) {
    context.commit('SET_LOADING', true);
    axios
      .get(`${process.env.VUE_APP_API_URL}/autoinfo/vehicle/license/${license}`)
      .then(result => {
        console.log('result:', result);
        context.commit('SET_VIN', result.data.data.VIN);
        context.commit('SET_LOADING', false);
      })
      .catch(err => {
        if (err.response && err.response.data) {
          this.dispatch('errors/update', {
            state: true,
            message: err.response.data.msg,
            snackbarMessage: `Error trying to fetch VIN`
          });
        } else {
          this.dispatch('errors/update', {
            state: true,
            message: err,
            snackbarMessage: `Unknown error trying to fetch VIN`
          });
        }
        context.commit('SET_LOADING', false);
      });
  }
};
